import axios from 'axios'
import L from 'leaflet'
import { sortBy, filter, findIndex } from 'lodash'
import { format, getSeconds, subSeconds } from 'date-fns'
import Highcharts from 'highcharts'
import more from 'highcharts/highcharts-more'
import { chartColors } from '../assets/colors'

more(Highcharts)

export const ten_min = 10 * 60 * 1000

export const five_min = 5 * 60 * 1000

export const kStart = 1
export const kPause = -1
export const kStop = 0

export const checkDate = (date) => {
  const seconds = getSeconds(new Date(date))
  return subSeconds(new Date(date), seconds)
}

export const getSessionData = (data) => {
  const data_filtered = filter(data, (point) => point.excluded === 0)
  let data_filtered_sort = sortBy(data_filtered, ['lat'])
  const r_min_lat = data_filtered_sort[0].lat
  const r_max_lat = data_filtered_sort[data_filtered_sort.length - 1].lat
  data_filtered_sort = sortBy(data_filtered, ['lng'])
  const r_min_lng = data_filtered_sort[0].lng
  const r_max_lng = data_filtered_sort[data_filtered_sort.length - 1].lng

  let data_sort = sortBy(data, ['lat'])
  const min_lat = data_sort[0].lat
  const max_lat = data_sort[data_sort.length - 1].lat
  data_sort = sortBy(data, ['lng'])
  const min_lng = data_sort[0].lng
  const max_lng = data_sort[data_sort.length - 1].lng

  /* data_filtered.forEach((position) => {
    r_min_lat = position.lat < r_min_lat ? position.lat : r_min_lat
    r_min_lng = position.lng < r_min_lng ? position.lng : r_min_lng
    r_max_lat = position.lat > r_max_lat ? position.lat : r_max_lat
    r_max_lng = position.lng > r_max_lng ? position.lng : r_max_lng
  })

  data.forEach((position) => {
    min_lat = position.lat < min_lat ? position.lat : min_lat
    min_lng = position.lng < min_lng ? position.lng : min_lng
    max_lat = position.lat > max_lat ? position.lat : max_lat
    max_lng = position.lng > max_lng ? position.lng : max_lng
  }) */

  const moy_lat = (min_lat + max_lat) / 2
  const moy_lng = (min_lng + max_lng) / 2
  const r_moy_lat = (r_min_lat + r_max_lat) / 2
  const r_moy_lng = (r_min_lng + r_max_lng) / 2

  /* const time_domain = [
    roundTime(data[0].timeU, -1),
    roundTime(data[data.length - 1].timeU, 1),
  ]
  const restricted_time_domain = [
    roundTime(data_filtered[0].timeU, -1),
    roundTime(data_filtered[data_filtered.length - 1].timeU, 1),
  ] */

  const time_domain = [data[0].timeU, data[data.length - 1].timeU]
  const restricted_time_domain = [
    data_filtered[0].timeU,
    data_filtered[data_filtered.length - 1].timeU,
  ]

  return {
    center: [moy_lat, moy_lng],
    restrictedCenter: [r_moy_lat, r_moy_lng],
    polygon: [
      [max_lat, max_lng],
      [max_lat, min_lng],
      [min_lat, min_lng],
      [min_lat, max_lng],
    ],
    restrictedPolygon: [
      [r_max_lat, r_max_lng],
      [r_max_lat, r_min_lng],
      [r_min_lat, r_min_lng],
      [r_min_lat, r_max_lng],
    ],
    timeDomain: time_domain,
    restrictedTimeDomain: restricted_time_domain,
  }
}

export const getChartData = (
  data,
  timeZone,
  restricted,
  origin,
  rigs,
  title,
  yTitle,
) => {
  const k_delta_min_between_max_speed = 30000

  const data_to_use = restricted
    ? filter(data, (point) => point.excluded === 0)
    : data
  /* const chart_data = data_to_use.map((position) => [
    position.timeU,
    position.speed,
  ]) */
  const chart_data = sortBy(
    data_to_use.map((position) => {
      return {
        x: position.timeU,
        y: position.speed,
      }
    }),
    (data) => data.x,
  )

  const sort_data = sortBy(
    filter(data_to_use, (point) => point.excluded === 0),
    ['speed'],
  ).reverse()
  const max_speed = sort_data[0].speed
  let max5Speed = []
  max5Speed.push(sort_data[0])
  let i = 1

  while (max5Speed.length < 5 && i < sort_data.length) {
    let flag = true
    const my_time = sort_data[i].timeU
    max5Speed.forEach((one) => {
      if (Math.abs(one.timeU - my_time) < k_delta_min_between_max_speed) {
        flag = false
      }
    })
    if (flag) {
      max5Speed.push(sort_data[i])
    }
    i++
  }

  //let j = 0
  max5Speed.map((value, index) => {
    const pos = findIndex(
      chart_data,
      (one) => value.timeU === /* one[0] */ one.x,
    )
    if (index < 3) {
      chart_data[pos] = {
        ...chart_data[pos],
        marker: {
          enabled: true,
          symbol: 'circle',
          fillColor: 'red',
          radius: 4,
        },
        /* maxS: 'max_' + (j + 1), */
        /* time: format(new Date(chart_data[pos].x), 'HH:mm:ss', {
          timeZone: timeZone,
        }),
        roundedSpeed: Math.round(chart_data[pos].y * 10) / 10, */
      }
    } /* else {
      chart_data[pos] = {
        ...chart_data[pos], */
    /*  id: 'max_' + (j + 1), */
    /* time: format(new Date(chart_data[pos].x), 'HH:mm:ss', {
          timeZone: timeZone,
        }),
        roundedSpeed: Math.round(chart_data[pos].y * 10) / 10,
      }
    } */
    //j++
    return null
  })

  //sortBy(chart_data, ['speed'])

  sortBy(rigs, 'start')
  let zones = []
  if (rigs !== null) {
    for (let i = 0; i < rigs.length; i++) {
      zones.push({ value: rigs[i].end, color: chartColors[i].color })
    }
  }

  let maxWidth
  let width
  const height = origin === 'stats' ? 260 : 200
  switch (origin) {
    case 'try':
      break
    case 'stats':
      break
    case 'rigs':
      break
    case 'tracks':
      width = '80%'
      break
    default:
      maxWidth = 2000

      break
  }

  const final_chart_data = sortBy(chart_data, (data) => {
    return data.x
  })

  const chart_options = {
    chart: {
      type:
        origin === 'try' ||
        origin === 'modify' ||
        origin === 'stats' ||
        origin === 'rigs'
          ? 'line'
          : 'scatter',
      height: height,
      backgroundColor: origin === 'stats' ? 'transparent' : '',
      // width: width,

      zoomType: '',
    },
    load: function () {
      const chart = this,
        titleHeight = chart.title.alignOptions.height,
        updatedHeight = chart.chartHeight + titleHeight
      chart.setSize(undefined, updatedHeight)
    },
    // responsive: {
    //   rules: [
    //     {
    //       condition: {
    //         maxWidth: maxWidth,
    //       },
    //     },
    //   ],
    // },

    title: {
      text: title,
      style: {
        fontSize: '12px',
      },
      verticalAlign: 'top',
    },
    tooltip: {
      enabled:
        origin === 'try' ||
        origin === 'modify' ||
        origin === 'stats' ||
        origin === 'rigs'
          ? true
          : false,
      positioner: function () {
        return { x: origin !== 'stats' ? 500 : 500, y: 40 }
      },
      formatter: function () {
        return (
          Math.round(this.y) +
          ' knts    ' +
          format(new Date(this.x), 'HH:mm', {
            timeZone: timeZone,
          })
        )
      },
      shadow: false,
      borderWidth: 0,
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      type: 'datetime',

      labels: {
        enabled: origin !== 'rigs',
        formatter: function () {
          return format(new Date(this.value), 'HH:mm', {
            timeZone: timeZone,
          })
        },
      },
      crosshair:
        origin === 'try' ||
        origin === 'stats' ||
        origin === 'modify' ||
        origin === 'rigs'
          ? {
              color: 'red',
              snap: true,
            }
          : false,
    },
    yAxis: {
      title: {
        text: yTitle,
      },
      max: max_speed + 10,
    },
    plotOptions: {
      series: {
        allowPointSelect: false,
        states: {
          hover: {
            enabled: false,
          },
        },
        marker: {
          radius: 1,
          states: {
            select: {
              fillColor: origin === 'tracks' ? 'lightgreen' : 'red',
              lineWidth: origin === 'try' ? 0 : 8,
              lineColor: origin === 'tracks' ? 'lightgreen' : 'red',
              radius: origin === 'try' ? 1 : 4,
            },
          },
        },
      },
    },

    series: [
      {
        turboThreshold: 50000, //** */
        data: final_chart_data,
        zoneAxis: 'x' /*important pour zones s'appliquent */,
        zones: zones,
      },
    ],
  }

  return {
    chartOptions: chart_options,
    /*maxSpeed: max_speed,*/
    max5Speed: max5Speed,
  }
}

export const getSpeedAndDistanceFromTrkpts = (data, restricted) => {
  const data_to_use = restricted
    ? filter(data, (point) => point.excluded === 0)
    : data

  let previous_pos = null
  let speed = 0
  let speedTime = 0
  let distance_part = 0
  let distance = 0

  data_to_use.forEach((position) => {
    if (previous_pos) {
      distance_part = get_distance_between(previous_pos, position)
      distance += distance_part
    }
    if (position.speed > speed) {
      speed = position.speed
      speedTime = position.timeU
    }
    previous_pos = position
  })

  return { speed, speedTime, distance }
}

export const getSpeedData = (data, restricted) => {
  const k_min_knt_stat = 10

  const data_to_use = restricted
    ? filter(data, (point) => point.excluded === 0)
    : data

  /* let max_speed = 0 */

  /* let chart_data = [] */
  let speedRanges = {
    total: 0,
    inf10: 0,
    sup10: 0,
    sup15: 0,
    sup20: 0,
    sup25: 0,
    sup30: 0,
  }

  let speedDistRanges = {
    total: 0,
    inf10: 0,
    sup10: 0,
    sup15: 0,
    sup20: 0,
    sup25: 0,
    sup30: 0,
  }

  let distance_part = 0
  let distance = 0
  let speedFrequency = []

  let previous_pos = null

  data_to_use.forEach((position) => {
    if (previous_pos) {
      distance_part = get_distance_between(previous_pos, position)
      distance += distance_part
    }
    if (position.speed > 3) {
      speedRanges.total++
      speedDistRanges.total += distance_part
      if (position.speed < 10) {
        speedRanges.inf10++
        speedDistRanges.inf10 += distance_part
      }

      if (position.speed >= 10 && position.speed < 15) {
        speedRanges.sup10++
        speedDistRanges.sup10 += distance_part
      }

      if (position.speed >= 15 && position.speed < 20) {
        speedRanges.sup15++
        speedDistRanges.sup15 += distance_part
      }
      if (position.speed >= 20 && position.speed < 25) {
        speedRanges.sup20++
        speedDistRanges.sup20 += distance_part
      }
      if (position.speed >= 25 && position.speed < 30) {
        speedRanges.sup25++
        speedDistRanges.sup25 += distance_part
      }
      if (position.speed >= 30) {
        speedRanges.sup30++
        speedDistRanges.sup30 += distance_part
      }
    }

    if (position.speed > k_min_knt_stat) {
      if (!speedFrequency[Math.round(position.speed)])
        speedFrequency[Math.round(position.speed)] = 1
      else speedFrequency[Math.round(position.speed)]++
    }

    previous_pos = position
  })

  if (speedRanges.total > 0) {
    speedRanges.inf10 = Math.round(
      (speedRanges.inf10 * 100) / speedRanges.total,
    )
    speedRanges.sup10 = Math.round(
      (speedRanges.sup10 * 100) / speedRanges.total,
    )
    speedRanges.sup15 = Math.round(
      (speedRanges.sup15 * 100) / speedRanges.total,
    )
    speedRanges.sup20 = Math.round(
      (speedRanges.sup20 * 100) / speedRanges.total,
    )
    speedRanges.sup25 = Math.round(
      (speedRanges.sup25 * 100) / speedRanges.total,
    )
    speedRanges.sup30 = Math.round(
      (speedRanges.sup30 * 100) / speedRanges.total,
    )
  }

  if (speedDistRanges.total > 0) {
    speedDistRanges.inf10 = Math.round(
      (speedDistRanges.inf10 * 100) / speedDistRanges.total,
    )
    speedDistRanges.sup10 = Math.round(
      (speedDistRanges.sup10 * 100) / speedDistRanges.total,
    )
    speedDistRanges.sup15 = Math.round(
      (speedDistRanges.sup15 * 100) / speedDistRanges.total,
    )
    speedDistRanges.sup20 = Math.round(
      (speedDistRanges.sup20 * 100) / speedDistRanges.total,
    )
    speedDistRanges.sup25 = Math.round(
      (speedDistRanges.sup25 * 100) / speedDistRanges.total,
    )
    speedDistRanges.sup30 = Math.round(
      (speedDistRanges.sup30 * 100) / speedDistRanges.total,
    )
  }

  return {
    speedRanges: speedRanges,
    speedDistRanges: speedDistRanges,
    distance: Math.round(distance / 100) / 10,
    speedFrequency: speedFrequency,
  }
}

export const getMapData = (data, restricted) => {
  const path_options = {
    color: 'red',
    weight: 1,
    opacity: 0.75,
    smooth_factor: 1,
  }

  const data_filtered = data.filter((point) => point.excluded === 0)

  let pos = []

  //let previous_pos = null

  const data_to_use = restricted ? data_filtered : data

  data_to_use.forEach((position) => {
    pos.push([position.lat, position.lng])

    //previous_pos = position
  })

  return {
    mapPath: { positions: pos, options: path_options },
  }
}

export const checkPointIsInRange = (range, point) => {
  const min = range[0]
  const max = range[1]
  return point.x >= min && point.x <= max
}

export const checkTrkptIsInRange = (range, trkpt) => {
  const min = range[0]
  const max = range[1]
  const time = Date.parse(trkpt.time)
  return time >= min && time <= max
}

export const ws_date = (date) => {
  return new Date(date).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const get_distance_between = (pt1, pt2) => {
  const k_R = 6371e3
  const deg_to_rad_coeff = Math.PI / 180
  const lat1 = pt1.lat
  const r_lat1 = lat1 * deg_to_rad_coeff
  const lon1 = pt1.lng
  //const r_lon1 = lon1 * deg_to_rad_coeff;
  const lat2 = pt2.lat
  const r_lat2 = lat2 * deg_to_rad_coeff
  const lon2 = pt2.lng
  //const r_lon2 = lon2 * deg_to_rad_coeff;
  const delta_lat = (lat2 - lat1) * deg_to_rad_coeff
  const delta_lon = (lon2 - lon1) * deg_to_rad_coeff

  const a =
    Math.pow(Math.sin(delta_lat / 2), 2) +
    Math.cos(r_lat1) * Math.cos(r_lat2) * Math.pow(Math.sin(delta_lon / 2), 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = k_R * c

  return d
}

export const axiosFetch = (url, post_data, db) => {
  let post_url
  switch (db) {
    case 'local':
      post_url = 'http://localhost/windsurf/' + url
      break
    case 'ovh':
      post_url = '/wind/windsurf/' + url
      break
    default:
      break
  }

  axios({
    method: 'post',
    url: post_url,
    data: post_data,
  })
    .then((result) => {
      /* console.log(result.data) */
      return { ok: true, data: result.data }
    })
    .catch((error) => {
      return { ok: false, data: error }
    })
}

export const do_speed_frequency_chart_options = (data, title, yTitle) => {
  return {
    chart: {
      type: 'column',
      height: 205,
      backgroundColor: 'transparent',
      /*       width: 300, */
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
        },
      ],
    },
    title: {
      text: title,
      style: {
        fontSize: '12px',
      },
      verticalAlign: 'bottom',
    },
    legend: {
      enabled: false,
    },

    yAxis: {
      title: {
        text: yTitle,
      },
    },

    series: [
      {
        name: 'Nombre ',
        data: data,
      },
    ],
  }
}

export const ColorLuminance = (hex, lum) => {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '')
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
  }
  lum = lum || 0

  // convert to decimal and change luminosity
  var rgb = '#',
    c,
    i
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16)
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16)
    rgb += ('00' + c).substr(c.length)
  }

  return rgb
}

export const multiPolylineFromArray = (coord_array, base_color) => {
  const smooth_angle = 3
  const lum_max = 1.0
  const lum_step = 0.4
  const speedThresholds = [10, 12, 14, 16, 18, 20, 22, 24]
  const colors = [
    ColorLuminance(base_color, lum_max),
    ColorLuminance(base_color, lum_max - 1 * lum_step),
    ColorLuminance(base_color, lum_max - 2 * lum_step),
    ColorLuminance(base_color, lum_max - 3 * lum_step),
    ColorLuminance(base_color, lum_max - 4 * lum_step),
    ColorLuminance(base_color, lum_max - 5 * lum_step),
    ColorLuminance(base_color, lum_max - 6 * lum_step),
    ColorLuminance(base_color, lum_max - 7 * lum_step),
    ColorLuminance(base_color, lum_max - 8 * lum_step),
  ]
  let multi = []
  let current_speed_class = -1
  let current_index = -1

  let pos_a = []
  let prev_x = 0
  let prev_y = 0

  coord_array.map((position) => {
    const new_speed = Math.trunc(position.speed)
    let i = 0
    let flag = false
    while (i < speedThresholds.length && !flag) {
      if (new_speed < speedThresholds[i]) flag = true
      i++
    }
    const new_speed_class = i
    if (new_speed_class !== current_speed_class) {
      if (current_index !== -1) multi[current_index].positions.push(position) //lien avec tableau précédent
      current_speed_class = new_speed_class
      current_index++
      multi[current_index] = {
        positions: [],
        pathOptions: {
          color: colors[new_speed_class],
          weight: 1,
          opacity: 0.75,
          smoothFactor: 1,
        },
      }
      multi[current_index].positions.push(position)
    } else {
      multi[current_index].positions.push(position)
    }
    pos_a.push({
      pos: { lat: position.lat, lng: position.lng },
      angle: 0,
      speed: new_speed,
    })
    return null
  })
  for (let i = 0; i < pos_a.length; i++) {
    const position = pos_a[i].pos
    const temp_point = L.latLng(position.lat, position.lng)
    const my_point = L.Projection.LonLat.project(temp_point)
    //const my_point = {x: k_R * Math.cos (position.lat) * Math.cos (position.lng), y: k_R * Math.cos (position.lat) * Math.sin (position.lng)};
    const dx = my_point.x - prev_x
    const dy = my_point.y - prev_y
    if (i > smooth_angle) {
      const prev_position = pos_a[i - smooth_angle].pos
      const prev_point = L.Projection.LonLat.project(
        L.latLng(prev_position.lat, prev_position.lng),
      )
      //const prev_point = {x: k_R * Math.cos (pos_a[i - smooth_angle].pos.lat) * Math.cos (pos_a[i - smooth_angle].pos.lng), y: k_R * Math.cos (pos_a[i - smooth_angle].pos.lat) * Math.sin (pos_a[i - smooth_angle].pos.lng)};
      prev_x = prev_point.x
      prev_y = prev_point.y
    } else {
      prev_x = my_point.x
      prev_y = my_point.y
    }
    const my_angle = (Math.atan2(dx, dy) * 180) / Math.PI
    pos_a[i].angle = my_angle
  }
  return { multi: multi, pos_a: pos_a }
}

export const formatDuration = (duration) => {
  const hours = Math.trunc(duration / 3600000)
  const minutes = Math.trunc((duration - 3600000 * hours) / 60000)
  return (
    (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes
  )
}

export const durationInMinutes = (duration) => {
  return Math.trunc(duration / 60000)
}

export const getDistanceBetween = (pt1, pt2, k_R) => {
  const deg_to_rad_coeff = Math.PI / 180
  const lat1 = pt1.lat
  const r_lat1 = lat1 * deg_to_rad_coeff
  const lon1 = pt1.lng
  //const r_lon1 = lon1 * deg_to_rad_coeff;
  const lat2 = pt2.lat
  const r_lat2 = lat2 * deg_to_rad_coeff
  const lon2 = pt2.lng
  //const r_lon2 = lon2 * deg_to_rad_coeff;
  const delta_lat = (lat2 - lat1) * deg_to_rad_coeff
  const delta_lon = (lon2 - lon1) * deg_to_rad_coeff

  const a =
    Math.pow(Math.sin(delta_lat / 2), 2) +
    Math.cos(r_lat1) * Math.cos(r_lat2) * Math.pow(Math.sin(delta_lon / 2), 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = k_R * c

  return d
}

export const do_meteo_chart_options = (
  data,
  sessionStart,
  sessionEnd,
  meteoStation,
  ch_lang,
  timeZone,
) => {
  const sort_data = sortBy(data, 'timeU')
  const labels = sort_data.map((ws) => {
    return ws.timeU
  })
  const avgSpeed = sort_data.map((ws) => {
    return ws.avgSpeed
  })
  const maxSpeed = sort_data.map((ws) => {
    return ws.maxSpeed
  })

  let range_moy_max_before = []
  let range_moy_max_session = []
  let range_moy_max_after = []
  for (let i = 0; i < labels.length; i++) {
    if (labels[i] < sessionStart) {
      range_moy_max_before.push([labels[i], avgSpeed[i], maxSpeed[i]])
    } else if (labels[i] > sessionEnd) {
      range_moy_max_after.push([labels[i], avgSpeed[i], maxSpeed[i]])
    } else {
      range_moy_max_session.push([labels[i], avgSpeed[i], maxSpeed[i]])
    }
  }

  return {
    chart: {
      height: 285,
    },
    /*  time: {
      timezoneOffset: -120,
    }, */
    title: {
      text: ch_lang.wind_chart_title,
      style: {
        fontSize: '12px',
      },
    },
    legend: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: 'knts',
      },
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: meteoStation,
      },
      labels: {
        enabled: false,
        formatter: function () {
          return format(new Date(this.value), 'HH:mm', {
            timeZone: timeZone,
          })
        },
      },
    },
    tooltip: {
      enabled: true,
      positioner: function () {
        return { x: 200, y: 25 }
      },
      formatter: function () {
        return (
          format(new Date(this.x), 'HH:mm', {
            timeZone: timeZone,
          }) +
          ' - avg : ' +
          this.point.low +
          ' - max : ' +
          this.point.high
        )
      },
      shadow: false,
      borderWidth: 0,
    },

    series: [
      {
        name: ch_lang.beforeSession,
        data: range_moy_max_before,
        type: 'arearange',
        lineWidth: 0,
        color: Highcharts.getOptions().colors[9],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false,
        },
      },
      {
        name: ch_lang.duringSession,
        data: range_moy_max_session,
        type: 'arearange',
        lineWidth: 0,
        color: Highcharts.getOptions().colors[0],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false,
        },
      },
      {
        name: ch_lang.afterSession,
        data: range_moy_max_after,
        type: 'arearange',
        lineWidth: 0,
        color: Highcharts.getOptions().colors[9],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false,
        },
      },
    ],
  }
}

export const getStrFromTrkpts = (trkpts) => {
  let myStr = ''
  trkpts.forEach((trkpt) => {
    myStr =
      myStr +
      trkpt.lat +
      ',' +
      trkpt.lng +
      ',' +
      trkpt.timeU +
      ',' +
      trkpt.time +
      ',' +
      trkpt.ele +
      ',' +
      trkpt.speed +
      ',' +
      trkpt.excluded +
      '*'
  })
  myStr = myStr.substring(0, myStr.length - 1)
  return myStr
}

export const getTrkptsFromStr = (myFinalStr) => {
  //const myFinalStr = LZString.decompressFromUTF16(myStr)

  const parts = myFinalStr.split('*')
  let trkpts = []
  parts.forEach((part) => {
    const trkpt = part.split(',')
    trkpts.push({
      lat: Number(trkpt[0]),
      lng: Number(trkpt[1]),
      timeU: Number(trkpt[2]),
      time: trkpt[3],
      ele: Number(trkpt[4]),
      speed: Number(trkpt[5]),
      excluded: Number(trkpt[6]),
    })
  })
  return trkpts
}

export const getMonthStatsChartOptions = (stats, type, cumul, choosenLang) => {
  const data = stats.map((yearStats) => {
    return {
      name: yearStats.year,
      data:
        type === 'nb'
          ? cumul === true
            ? yearStats.monthCumulNb
            : yearStats.monthNb
          : cumul === true
          ? yearStats.monthCumulDuration
          : yearStats.monthDuration,
    }
  })
  const options = {
    chart: {
      backgroundColor: 'transparent',
      type: 'line',
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
            maxHeight: 500,
          },
        },
      ],
    },
    title: {
      text: '',
      style: {
        fontSize: '10px',
        fontWeight: 'bold',
      },
      verticalAlign: 'bottom',
    },
    tooltip: {
      /* pointFormat:
        type === 'nb'
          ? '<b>{series.name} : {point.y} sessions</b>'
          : '<b>{series.name} : {formatDuration(point.y)}', */
      pointFormatter:
        type === 'nb'
          ? function () {
              return (
                '<b>' +
                this.series.name +
                ' : ' +
                this.y +
                ' session' +
                (this.y > 1 ? 's' : '') +
                '</b>'
              )
            }
          : function () {
              const temp = formatDuration(this.y)
              return this.series.name + ' : ' + temp
            },
    },
    legend: {
      enabled: true,
    },
    xAxis: {
      type: 'category',
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      title: {
        text: type === 'nb' ? choosenLang.nbX : choosenLang.durationX,
      },
    },
    yAxis: {
      tickInterval: type === 'nb' ? 5 : undefined,
      title: {
        text: type === 'nb' ? choosenLang.nbY : choosenLang.durationY,
      },
      type: type === 'nb' ? undefined : 'datetime',
      labels: {
        formatter:
          type === 'nb'
            ? undefined
            : function () {
                const temp = formatDuration(this.value)
                return temp
              },
      },
    },
    series: data,
  }
  return options
}

export const getSpeedAndDistanceOptions = (datas, type, choosenLang) => {
  let categories = []
  let series = []
  datas.forEach((data) => {
    categories.push(data.date.toLocaleDateString())
    series.push(type === 'speed' ? data.speed : data.distance)
  })
  const options = {
    chart: {
      backgroundColor: 'transparent',
      type: 'line',
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
            maxHeight: 500,
          },
        },
      ],
    },
    title: {
      text: '',
      style: {
        fontSize: '10px',
        fontWeight: 'bold',
      },
      verticalAlign: 'bottom',
    },
    tooltip: {
      pointFormatter: function () {
        return (
          Math.round(this.y * 10) / 10 + (type === 'speed' ? ' knt' : ' km')
        )
      },
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      //type: 'datetime',
      categories: categories,
      title: {
        text: type === 'speed' ? choosenLang.maxSpeedX : choosenLang.distanceX,
      },
    },
    yAxis: {
      tickInterval: type === 'nb' ? 5 : undefined,
      title: {
        text: type === 'speed' ? choosenLang.maxSpeedY : choosenLang.distanceY,
      },
    },
    series: [{ name: 'speedAndDistance', data: series }],
  }

  return options
}

export const setLogItem = (log) => {
  const url = '/api/log/createLog'
  fetch(url, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(log),
  })
    .then(() => {
      console.log('log')
    })
    .catch((error) => console.log(error))
}

export const callApiGet = async (what) => {
  const url = what.url
  const postData = what.postData
  const dc = decodeURIComponent(document.cookie)
  const sdc = dc.split('=')[1]
  const ws = sdc.split(';')[0]
  return await new Promise((resolve, reject) => {
    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        response.json().then((data) => {
          resolve(data)
        })
      })
      .catch((error) => {
        console.log('Error getting data', error)
        reject({ error: error })
      })
  })
}

export const getWindDirection = (angle) => {
  const zones = [
    'N',
    'NNE',
    'NE',
    'ENE',
    'E',
    'ESE',
    'SE',
    'SSE',
    'S',
    'SSO',
    'SO',
    'OSO',
    'O',
    'ONO',
    'NO',
    'NNO',
  ]
  const zone = Math.round(angle / 22.5)
  return zones[zone]
}
